import { useEffect, useState } from "react";

import useAuth from "@/hooks/use-auth";

import { DistanceIcon, RatingIcon, ScoreIcon } from "../icons";
import { SortEnum } from "../types";

interface SortOptionType {
  icon: React.ReactNode;
  label: React.ReactNode;
}

type SortOptionsType = { [keyof in SortEnum]?: SortOptionType };

export default function useSortMenuOptions(all = false) {
  const { isAuthenticated } = useAuth();

  const defaultOptions: SortOptionsType = {
    [SortEnum.DISTANCE]: {
      icon: <DistanceIcon />,
      label: "Distance",
    },
    [SortEnum.COMMUNITY_SCORE]: {
      icon: <ScoreIcon />,
      label: "Community score",
    },
  };

  if (all) {
    defaultOptions[SortEnum.MY_RATING] = {
      icon: <RatingIcon />,
      label: "My rating",
    };
  }

  const [options, setOptions] = useState<SortOptionsType>(defaultOptions);

  // biome-ignore lint/correctness/useExhaustiveDependencies: its probably fine
  useEffect(() => {
    if (all) {
      return;
    }

    setOptions(
      isAuthenticated
        ? {
            ...defaultOptions,
            [SortEnum.MY_RATING]: {
              icon: <RatingIcon />,
              label: "My rating",
            },
          }
        : defaultOptions
    );
  }, [isAuthenticated, all]);

  return options;
}
